// © 2026 Orpyx Medical Technologies Inc.
import * as React from "react";
import {memo} from "react";
import Button from "@material-ui/core/Button";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import {createStyles, Theme} from "@material-ui/core";
import {makeStyles} from "@material-ui/styles";
import {Teal} from "orpyx-web-common";
import {IGetPatientsListResponse} from "doctors-dashboard/http-clients/index";
import {ORPYX_PORTAL_URL} from "../../../../../../appConstants";

export interface PatientsListOpenInPortalButtonProps {
    readonly patient: IGetPatientsListResponse;
}

const usePatientsListOpenInPortalButtonStyle = makeStyles((theme: Theme) => createStyles({
    root: {
        color: Teal,
        whiteSpace: 'nowrap',
    },

    icon: {
        fontSize: '15px',
        marginLeft: '5px',
    },
}));

const portalPatientUrl = (patient: IGetPatientsListResponse): string | undefined => {
    if (!ORPYX_PORTAL_URL || !patient.patientId)
        return undefined;

    return `${ORPYX_PORTAL_URL}/patients/${patient.patientId}`;
};

export const PatientsListOpenInPortalButton = memo((props: PatientsListOpenInPortalButtonProps) => {
    const classes = usePatientsListOpenInPortalButtonStyle();

    const url = portalPatientUrl(props.patient);

    if (!url)
        return null;

    return (
        <Button
            className={classes.root}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            title="Open this patient's record in the Orpyx Portal"
            id={`patients-list-open-in-portal-button-${props.patient.patientId}`}
            onClick={event => event.stopPropagation()}
        >
            View in Orpyx Portal
            <OpenInNewIcon className={classes.icon}/>
        </Button>
    );
});
